real.events.on('video:progress', notification => {
    const videoTranscoding = $('.video-transcoding[data-uploadedfile-id="' + notification.object.uploadedfile.id + '"]');
    if (videoTranscoding.length === 0) {
        return;
    }
    const progressBar = videoTranscoding.find('.video-transcoding-progress');
    howspace.components.progress.update(progressBar, notification.object.progress.percents);
});
